import { FETCH_PRODUCTS_REQUEST } from './../const';

export default () => {
  return {type: FETCH_PRODUCTS_REQUEST}
};
